import { ReactNode } from "react";
import "./success-display.style.scss";

interface SuccessDisplayProps {
	title: string;
	description: string;
	children?: ReactNode;
}

// CSS-only success state (checkmark draw-in, no confetti) — used in place of
// showToastMessage(msg, "S") on TanStack Query mutations, see FormError for the error side.
export default function SuccessDisplay({ title, description, children }: SuccessDisplayProps) {
	return (
		<div className="success-display">
			<svg viewBox="0 0 120 120" className="success-display__icon" aria-hidden="true" focusable="false">
				<circle cx="60" cy="60" r="46" className="success-display__circle" />
				<path d="M 34 62 L 51 79 L 86 44" className="success-display__tick" />
			</svg>

			<div className="success-display__text">
				<h3>{title}</h3>
				<p>{description}</p>
			</div>

			{children && <div className="success-display__actions">{children}</div>}
		</div>
	);
}
